import * as apiGetMatchProduct from 'api/match/GetMatchProductNew';
import * as Criterion from 'types/Recipe/Detail/Erp/Criterion';
import * as Product from 'types/Recipe/Detail/Erp/Product';

export type Type = Product.Type[];

export function create(): Type {
	return [];
}

export async function getFromApi(input: apiGetMatchProduct.Request): Promise<Type> {
	const response = await apiGetMatchProduct.callApi(input);
	const erpMatch: apiGetMatchProduct.ResponseData = response.getOrDefault({});
	return mapFromApi(erpMatch);
}

export async function getFromApiByIngredientIdList(ids: string[]): Promise<Type> {
	const output: Type = [];
	for (const id of ids) {
		const response = await getFromApi({
			...Criterion.create([id]),
			type: 'id',
			pageSize: 1,
			pageIndex: 0,
		});
		if (response[0]) output.push(response[0]);
	}
	return output;
}

export function mapFromApi(input: apiGetMatchProduct.ResponseData): Type {
	const output: Type = [];
	for (const [source, ingredientInfo] of Object.entries(input)) {
		const value = Object.values(ingredientInfo)[0];
		for (const i of value) {
			output.push(Product.mapFromApi(i, source));
		}
	}
	return output;
}

export function getFromId(obj: Type, id: string | null): Product.Type | null {
	if (!id) return null;
	const output: Product.Type | undefined = obj.find((e) => e.id === id);
	if (!output) return null;
	return output;
}

export function getServingSize(obj: Type, matchLeftId: string | null, matchRightId: string | null) {
	if (matchLeftId) {
		const product = getFromId(obj, matchLeftId);
		if (product) return product.servingSizeQuantityGram ?? 100;
	}
	if (matchRightId) {
		const product = getFromId(obj, matchRightId);
		if (product) return product.servingSizeQuantityGram ?? 100;
	}

	return 100;
}
